import { merge, get, set, clone, concat } from 'lodash';
import { ACTIONBASEINFO, ACITONCOPYRIGHT } from '../../../actionTypes';
let initState = {
	albumList: [],
	totalCount: 5,
	pageIndex: 1,
	pageSize: 5
};
export function CopyrightActivityListReducers(state = initState, action) {
	switch (action.type) {
		case ACITONCOPYRIGHT.SET_ACTIVITYLIST_LIST: {
			let payload = get(action, 'payload', {});
			let { totalCount, pageIndex, records = [] } = payload || {};
			if (records.length > 0) {
				if (pageIndex === 1) {
					state.albumList = records;
				} else {
					state.albumList = concat(state.albumList, records);
				}
				return merge({}, state, { totalCount, pageIndex });
			}
			return state;
		}
		default:
			return state;
	}
}
